import { BellRing } from "lucide-react";
import { EnquiryForm } from "./EnquiryForm";

/** "Send me new homes near X" capture — saved to the team inbox; an agent sends matches as they list. */
export const AlertsBand = ({ base }) => (
  <section className="bg-ink py-14 text-white sm:py-16" data-testid="alerts-band">
    <div className="mx-auto grid w-full max-w-[1240px] gap-10 px-5 sm:px-8 lg:grid-cols-[1fr_1.1fr]">
      <div>
        <span className="grid h-11 w-11 place-items-center rounded-full bg-brass text-ink"><BellRing className="h-5 w-5" /></span>
        <h2 className="mt-5 font-display text-3xl font-normal sm:text-4xl">Be first to new homes near {base?.short || "your base"}</h2>
        <p className="mt-3 max-w-md text-[16px] leading-relaxed text-white/80">
          Tell us your budget and must-haves. An agent on our team will send you new listings inside your commute radius as soon as they hit the market.
        </p>
      </div>
      <div className="rounded-md bg-white p-5 text-ink sm:p-6">
        <EnquiryForm kind="alerts" defaultBaseId={base?.id} extras={["base", "reportDate"]} submitLabel="Send me new listings"
          testIdPrefix="alerts" messagePlaceholder="Budget, beds, max commute, school needs…" />
      </div>
    </div>
  </section>
);
